import { render, staticRenderFns } from "./bidEvaluationMethodList.vue?vue&type=template&id=648eb7a8&scoped=true"
import script from "./bidEvaluationMethodList.vue?vue&type=script&lang=js"
export * from "./bidEvaluationMethodList.vue?vue&type=script&lang=js"
import style0 from "./bidEvaluationMethodList.vue?vue&type=style&index=0&id=648eb7a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648eb7a8",
  null
  
)

export default component.exports